import { render, staticRenderFns } from "./staging.vue?vue&type=template&id=ff885e24&scoped=true"
import script from "./staging.vue?vue&type=script&lang=js"
export * from "./staging.vue?vue&type=script&lang=js"
import style0 from "./staging.vue?vue&type=style&index=0&id=ff885e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff885e24",
  null
  
)

export default component.exports